exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n/* .card-body >>> table > tbody > tr > td {\n    cursor: pointer;\n}\n\ninput[type=texte] {\n    width: 100%;\n    padding: 12px 20px;\n    margin: 4px 0;\n    box-sizing: border-box;\n    border: none;\n    background-color: white;\n    color: white;\n} */\n.accordion .card-header[data-v-fe920914] {\n\tbackground-color: white;\n}\n.accordion .card-header button[data-v-fe920914] {\n\tfont-weight: bold;\n\tcolor: #323635;\n}\n.accordion .card-body span[data-v-fe920914] {\n\tdisplay: block;\n\tmax-width: 80ch;\n}\n.card-tip[data-v-fe920914] {\n\tborder-left-color: #007949;\n\tborder-left-width: 6px;\n\tmax-width: 80ch;\n}\n", ""]);

// exports
